import { useMemo } from "react";
import {
  useGetAllNotesQuery,
  useGetAllPersonsQuery,
  useGetCalendarEventsQuery,
} from "@/services/api";
import { useAppSelector } from "@/services/store";
import { calendarSliceSelectors } from "@/features/calendar/model";
import type { Dayjs } from "dayjs";
import { getCurrentDayEvents } from "../utils";

export const useCalendarEvents = (currentCellDate: Dayjs) => {
  const dateRange = useAppSelector(calendarSliceSelectors.selectDateRange);
  const { data, isFetching } = useGetCalendarEventsQuery(dateRange);
  const { isFetching: notesIsLoading } = useGetAllNotesQuery();
  const { isFetching: personsIsLoading } = useGetAllPersonsQuery();

  const currentDateEvents = useMemo(() => {
    return getCurrentDayEvents(currentCellDate, data);
  }, [data, currentCellDate]);

  return {
    isFetching: isFetching || notesIsLoading || personsIsLoading,
    currentDateEvents,
    hasEvents: Object.values(currentDateEvents).some((array) => array.length > 0),
  };
};
